<form class="flex h-32 w-80 flex-col px-5 py-5">
    <h1 class="mb-5 text-center text-xl">Upload file</h1>
    <input
        #fileInput
        class="hidden"
        (change)="onFileUploaded($event)"
        type="file"
        [accept]="data.accept" />
    @if (!form.controls.file.value) {
        <button
            type="button"
            mat-flat-button
            color="primary"
            (click)="fileInput.click()">
            Upload
        </button>
    } @else {
        <button
            type="button"
            mat-flat-button
            color="primary"
            (click)="close()">
            Save
        </button>
    }
</form>
